module.exports = __webpack_public_path__ + "img/HN.479bb62e.png";